import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'AssociatedPersonnel',
  //   description: 'description of AssociatedPersonnel',
  //   url: '/associated-personnel',
  // },
];

export default help;
